import EverTrue from 'app';
import BaseRouter from 'base/base-router';
import SavedSearchIndexController from 'apps/segments/controllers/saved-search-index-controller';

class SegmentsRouter extends BaseRouter {
  static initClass() {
    this.prototype.routes = {
      segments: 'segments',
    };
  }

  segments() {
    EverTrue.execute('setBrowserTitle', 'Segments');
    window.scrollTo(0, 0);
    EverTrue.track.set('viewed', { type: 'saved_searches' });
    this.currentView = <SavedSearchIndexController />;
    EverTrue.page.mount(this.currentView);
  }
}

SegmentsRouter.initClass();
export default SegmentsRouter;
